import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getAuthHeader, handleResponse, API_BASE_URL, images } from '../utils/api';

export default function PopulationHistory() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const { notificationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const headers = await getAuthHeader('GET');
        const response = await fetch(`${API_BASE_URL}/population-history/${notificationId}`, {
          method: 'GET',
          headers,
          credentials: 'include'
        });
        const data = await handleResponse(response);
        setHistoryData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [notificationId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="text-red-600 mb-4">Error: {error}</div>
        <button
          onClick={() => navigate(-1)}
          className="text-indigo-600 hover:text-indigo-900"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Population Updates</h1>
        <button
          onClick={() => navigate(-1)}
          className="text-indigo-600 hover:text-indigo-900"
        >
          Go Back
        </button>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Image
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Coin Details
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Previous Population
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Current Population
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {historyData.map((entry) => (
                <tr key={entry.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 w-24">
                    <Link to={`/coins/${entry.coin_id}`}>
                      <img 
                        src={entry.images?.length ? images.getImage(entry.images[0].thumbnail_path, entry.images[0].source) : '/images/placeholder.svg'} 
                        alt="Coin thumbnail" 
                        className="w-20 h-20 object-contain rounded"
                      />
                    </Link>
                  </td>
                  <td className="px-6 py-4">
                    <Link 
                      to={`/coins/${entry.coin_id}`}
                      className="text-sm font-medium text-indigo-600 hover:text-indigo-900"
                    >
                      <div className="text-sm font-medium">
                        {[
                          entry.country,
                          `${entry.year}${entry.mint_mark ? `-${entry.mint_mark}` : ''}`,
                          entry.denomination,
                          entry.variety,
                          `${entry.certification_service_name} ${entry.grade}`
                        ].filter(Boolean).join(' ')}
                      </div>
                    </Link>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {`${entry.old_population || '0'}/${entry.old_population_higher || '0'}`}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {`${entry.new_population || '0'}/${entry.new_population_higher || '0'}`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
